import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { localizeReducer } from 'react-localize-redux';
import auth from './auth.reducer';
import app from './app.reducer';
import webSocket from './webSocket.reducer';

const appReducer = combineReducers({
	auth,
	app,
	localize: localizeReducer,
	form: formReducer,
	webSocket
});

const rootReducer = (state, action) => {
	if (action.type === 'LOGOUT_SUCCESS') {
		state = undefined;
	}

	return appReducer(state, action);
};

export default rootReducer;
